'use strict';

import {Input} from './validatable-input-field';
import {email} from 'helpers/email-validation';

function createErrorNode(errorClass, modifier) {
  var errorMessage = document.createElement('small');
  errorMessage.classList.add('u-icon');
  errorMessage.classList.add('u-icon--negative-feedback');
  errorMessage.classList.add(errorClass);
  if(modifier) {
    errorMessage.classList.add(modifier);
  }
  return errorMessage;
}

function displayValidField(inputField) {
  inputField.replace('input--invalid', 'input--valid');
  inputField.hideErrorMessage();
}

function clearEmailValidation(inputField) {
  inputField.hideErrorMessage();
  inputField.removeClass('input--invalid');
  inputField.removeClass('input--valid');
}

function displayIncompleteErrorMessage(inputField) {
  inputField.showErrorMessage();
  highlightIncompleteField(inputField);
}

function highlightIncompleteField(inputField) {
  inputField.replace('input--valid', 'input--invalid');
}

export var emailInput = {
  create: function(element, modifier) {
    return Input.validatable(element, {
      errorNode: createErrorNode('email-valid-info', modifier),
      validators: [email.validate],
      onValid: displayValidField,
      onClear: clearEmailValidation,
      onIncomplete: displayIncompleteErrorMessage,
      onCorrection: clearEmailValidation
    });
  }
};
